export const enFeedback = {
    feedback: {
        title : 'Feedback',
        subtitle : 'Manage and analyze customer feedback to improve your services',
        filter: {
            allItems : 'All Items',
            all : 'All Sentiment',
            positive : 'Positive',
            negative : 'Negative',
            customer : 'Direct Feedbacks',
            ai : 'AI-Driven Feedbacks',
        },
        general : 'General',
        itemFeedback : 'Items',
        generalDesc : 'Overall restaurant experience',
        itemDesc : 'Feedback about specific menu items',
        noGeneral : 'No general feedback',
        noItem : 'No item feedback',
        ratings : 'ratings',
        review : 'review',
        reviews : 'reviews',
        rated : 'rated',
    },
};